import clsx, { type ClassValue } from 'clsx';

/**
 * Utility function to merge classnames
 * Combines clsx for conditional classes with tailwind merge to handle conflicts
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
